import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    id: "career-modal",
    class: "modal type2 js-modal"
};
const _hoisted_2 = { class: "modal-content" };
const _hoisted_3 = { class: "close_bt bt_modal_close" };
const _hoisted_4 = { class: "pop" };
const _hoisted_5 = { for: "job1_2_a1" };
const _hoisted_6 = { class: "bt_box clear" };
const _hoisted_7 = {
    key: 0,
    class: "err_list"
};
import { ref, watch } from 'vue';
import ImageFrame from '@component/ImageFrame.vue';
import Alert from '@util/BrowserAlert';
import Formatter from '@util/Formatter';
import { nextTick } from 'process';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CareerModal',
    props: {
        form: {},
        errors: {}
    },
    emits: ['input', 'cancel'],
    setup(__props, { expose: __expose, emit: __emit }) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        const props = __props;
        const emit = __emit;
        const close = ref();
        const focus_target = ref();
        let modal_inital_status = true;
        let form = ref({
            career_id: (_b = (_a = props.form) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null,
            started_at: (_d = (_c = props.form) === null || _c === void 0 ? void 0 : _c.started_at) !== null && _d !== void 0 ? _d : '',
            is_ended: (_f = (_e = props.form) === null || _e === void 0 ? void 0 : _e.is_ended) !== null && _f !== void 0 ? _f : true,
            ended_at: (_h = (_g = props.form) === null || _g === void 0 ? void 0 : _g.ended_at) !== null && _h !== void 0 ? _h : null,
            organization: (_k = (_j = props.form) === null || _j === void 0 ? void 0 : _j.organization) !== null && _k !== void 0 ? _k : '',
            department: (_m = (_l = props.form) === null || _l === void 0 ? void 0 : _l.department) !== null && _m !== void 0 ? _m : '',
            position: (_p = (_o = props.form) === null || _o === void 0 ? void 0 : _o.position) !== null && _p !== void 0 ? _p : '',
            experience_content: (_r = (_q = props.form) === null || _q === void 0 ? void 0 : _q.experience_content) !== null && _r !== void 0 ? _r : '',
        });
        watch(() => form.value.ended_at, (value) => form.value.is_ended = value === null);
        watch(() => props.form, (value) => {
            // focusing the top of content.
            if (!value.id && modal_inital_status) {
                modal_inital_status = false;
                const focusTarget = focus_target.value;
                nextTick(() => {
                    focusTarget.focus();
                });
            }
            ;
            if (value) {
                form.value = value;
            }
        }, { deep: true });
        // 文字数チェック
        watch(() => form.value.organization, (value) => {
            if (Alert.charLimitText(value)) {
                form.value.organization = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.value.department, (value) => {
            if (Alert.charLimitText(value)) {
                form.value.department = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.value.position, (value) => {
            if (Alert.charLimitText(value)) {
                form.value.position = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.value.experience_content, (value) => {
            if (Alert.charLimitTextArea(value)) {
                form.value.experience_content = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        // キャンセルボタン
        const onClickCancel = () => {
            modal_inital_status = true;
            emit('cancel');
        };
        const onClickOK = () => {
            form.value.started_at = Formatter.formatDate(form.value.started_at, 'YYYY/MM');
            let endedAt = Formatter.formatDate(form.value.ended_at, 'YYYY/MM');
            form.value.ended_at = endedAt;
            form.value.is_ended = endedAt.trim() == '';
            emit('input', form.value);
        };
        const onCloseModal = () => {
            modal_inital_status = true;
            close.value.click();
            emit('cancel');
        };
        const onInputStartedAt = (event) => {
            form.value.started_at = event.target.value;
        };
        const onInputEndedAt = (event) => {
            form.value.ended_at = event.target.value;
        };
        __expose({
            onCloseModal,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "modal-bg bt_modal_close",
                    onClick: onClickCancel
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(ImageFrame, {
                            src: "images/common/i_bt_close.svg",
                            onClick: onClickCancel
                        })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _cache[16] || (_cache[16] = _createElementVNode("h2", null, "職歴登録", -1)),
                        _createElementVNode("dl", null, [
                            _cache[10] || (_cache[10] = _createElementVNode("dt", null, "開始時期", -1)),
                            _createElementVNode("dd", null, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).started_at) = $event)),
                                    type: "text",
                                    name: "ym_1_1",
                                    class: "c-ym",
                                    placeholder: "日付選択▼",
                                    onInput: onInputStartedAt,
                                    autocomplete: "off"
                                }, null, 544), [
                                    [_vModelText, _unref(form).started_at]
                                ])
                            ]),
                            _cache[11] || (_cache[11] = _createElementVNode("dt", null, "終了時期", -1)),
                            _createElementVNode("dd", null, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).is_ended) = $event)),
                                    value: false,
                                    class: "visually-hidden",
                                    type: "radio",
                                    name: "job1_2",
                                    id: "job1_2_a1",
                                    ref_key: "focus_target",
                                    ref: focus_target
                                }, null, 512), [
                                    [_vModelRadio, _unref(form).is_ended]
                                ]),
                                _createElementVNode("label", _hoisted_5, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).ended_at) = $event)),
                                        type: "text",
                                        name: "ym_1_2",
                                        class: "c-ym",
                                        placeholder: "日付選択▼",
                                        onInput: onInputEndedAt,
                                        autocomplete: "off"
                                    }, null, 544), [
                                        [_vModelText, _unref(form).ended_at]
                                    ])
                                ]),
                                _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(form).is_ended) = $event)),
                                    value: true,
                                    class: "visually-hidden",
                                    type: "radio",
                                    name: "job1_2",
                                    id: "job1_2_a2"
                                }, null, 512), [
                                    [_vModelRadio, _unref(form).is_ended]
                                ]),
                                _cache[9] || (_cache[9] = _createElementVNode("label", { for: "job1_2_a2" }, "在籍中", -1))
                            ]),
                            _cache[12] || (_cache[12] = _createElementVNode("dt", null, "組織", -1)),
                            _createElementVNode("dd", null, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(form).organization) = $event)),
                                    type: "text",
                                    name: "job1_3",
                                    class: "wmax inquiry-form",
                                    placeholder: "組織名"
                                }, null, 512), [
                                    [_vModelText, _unref(form).organization]
                                ])
                            ]),
                            _cache[13] || (_cache[13] = _createElementVNode("dt", null, "部署", -1)),
                            _createElementVNode("dd", null, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(form).department) = $event)),
                                    type: "text",
                                    name: "job1_4",
                                    class: "wmax inquiry-form",
                                    placeholder: "部署"
                                }, null, 512), [
                                    [_vModelText, _unref(form).department]
                                ])
                            ]),
                            _cache[14] || (_cache[14] = _createElementVNode("dt", null, "役職", -1)),
                            _createElementVNode("dd", null, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(form).position) = $event)),
                                    type: "text",
                                    name: "job1_5",
                                    class: "wmax inquiry-form",
                                    placeholder: "役職"
                                }, null, 512), [
                                    [_vModelText, _unref(form).position]
                                ])
                            ]),
                            _cache[15] || (_cache[15] = _createElementVNode("dt", null, [
                                _createTextVNode(" 経験内容"),
                                _createElementVNode("br", { class: "pc" }),
                                _createElementVNode("p", { class: "sub" }, "要約、規模、担当業務、担当実績、etc.")
                            ], -1)),
                            _createElementVNode("dd", null, [
                                _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(form).experience_content) = $event)),
                                    placeholder: "経験内容",
                                    id: "textarea_experience-content",
                                    oninput: "resizeTextarea('experience-content',7)"
                                }, null, 512), [
                                    [_vModelText, _unref(form).experience_content]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            (props === null || props === void 0 ? void 0 : props.errors)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (error) => {
                                        return (_openBlock(), _createElementBlock("p", null, _toDisplayString(error), 1));
                                    }), 256))
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                _createElementVNode("li", null, [
                                    _createElementVNode("p", {
                                        class: "bt_modal_close bt_clear",
                                        onClick: onClickCancel
                                    }, "キャンセル")
                                ]),
                                _createElementVNode("li", null, [
                                    _createElementVNode("p", {
                                        class: "bt_ok",
                                        onClick: onClickOK
                                    }, "OK")
                                ])
                            ]),
                            _createElementVNode("p", {
                                class: "bt_modal_close",
                                ref_key: "close",
                                ref: close,
                                style: { "display": "none" }
                            }, null, 512)
                        ])
                    ])
                ])
            ]));
        };
    }
});
